export default {
    caravane: '80ecdfe6-df2c-46c4-bb28-8a0cd2f33857',
    chambre: '47716fae-ab8e-4c31-9700-223c49e5b267',
    apartment: '22032ecc-f596-4074-8767-3de4fbdd36f2',
    boat: 'ab9d65b6-af84-4b97-93e5-2bd0abf5eb08',
    bungalow: 'b223818c-1a5b-43a8-9ab6-1e34013d8b22',
    chalet: 'ea773c25-a4aa-4b52-967f-8938d2cbfd8f',
    chateau: '22b01b68-853c-4968-b4b4-8cc3b869a385',
    cottage: '28bab415-cf0e-4475-abe5-1252a24fe43a',
    farmhouse: 'cf203701-6618-4a90-afc4-1aa78bb2fd4c',
    villa: '0e27ea7f-b3d0-4e1e-9c39-a54388fb580e',
    cabin: '26379463-538b-447f-9b27-eefe0b4a86ef',
    house: 'a3e9e9ec-f91b-420d-92bf-720466ff47e9',
    barn: '09abca53-e797-4824-82e0-ef764b6fc027',
    castle: 'b21d5e82-8be0-4158-8169-d0083717b1dd',
    condo: '81643fe3-de85-4a11-8c0a-1b3133d481c4',
    estate: '7b424416-121d-4c9c-8d49-c54af4a54ccf',
    lodge: '0fb12030-785f-4028-8fe0-0c622821e0b6',
    resort: 'f471cdda-258c-484d-a65f-4427944f1a75',
    studio: 'c09f93fe-485b-43a1-894f-f3c0bc749c5e',
    townhome: '9887ca9c-5c9c-46aa-8fa1-7208e2ee6981',
    yacht: '4fee716c-d301-4a55-bafc-244a58e8efdf',
    houseboat: '285f445f-1950-48ee-a4bf-392644176aff',
    mobile_home: '7aee41a3-2447-481d-af19-66eb63c77bac',
    countryhouse: 'ff615d67-885d-471c-9bcf-15010bc445a6',
    mill: '9ef4a74f-8a3e-46ea-a28d-2c05d16cfe01',
    tower: '7affdbd6-55de-497e-87fb-dc4b8fe5847e',
    suite: 'd2447e2a-a554-4cd4-98a5-ae137568cd46'
};
